import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations
import {
	BreakpointWidth
} from '@app/enumerations';

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		formCoverageLimitsCommercial_container: {

		},
		formCoverageLimitsCommercial_perilDeductibles: {

		},
		formCoverageLimitsCommercial_perilDeductiblesLabel: {
			color: theme.palette.info.main,
			fontWeight: theme.typography.fontWeightBold as any,
			fontSize: theme.typography.h5.fontSize,
		},
		formCoverageLimitsCommercial_coverageLimitsContainer: {

		},
		formCoverageLimitsCommercial_coverageLimitsLabel: {
			color: theme.palette.info.main,
			fontWeight: theme.typography.fontWeightBold as any,
			fontSize: theme.typography.h5.fontSize,
			paddingBottom: theme.spacing(1),
		},
		formCoverageLimitsCommercial_coverageLimitsBody: {
			display: 'flex',
			justifyContent: 'space-between',
			flexWrap: 'wrap',
			[theme.breakpoints.up(BreakpointWidth.X_LARGE)]: {
				flexDirection: 'row',
			},
			[theme.breakpoints.down(BreakpointWidth.X_LARGE)]: {
				flexDirection: 'column',
			},
		},
		formCoverageLimitsCommercial_coverageLimitsItemWrapper: {
			display: 'flex',
			flexDirection: 'column',
			[theme.breakpoints.up(BreakpointWidth.X_LARGE)]: {
				padding: theme.spacing(3, 0),
				width: '450px',
			},
			[theme.breakpoints.down(BreakpointWidth.X_LARGE)]: {
				padding: theme.spacing(3, 0),
				flex: '1 0',
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				padding: theme.spacing(0),
			},
		},
		formCoverageLimitsCommercial_coverageLimitsOptionButtonsBody: {
			display: 'flex',
			flexWrap: 'wrap',
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				padding: theme.spacing(3, 0, 0, 0),
			},
		},
		formCoverageLimitsCommercial_coverageLimitsCalculatePremiumButton: {
			marginRight: theme.spacing(3),
			padding: theme.spacing(1, 0),
		},
		formCoverageLimitsCommercial_coverageLimitsAddBuildingButton: {
			padding: theme.spacing(1, 0),
		},
		formCoverageLimitsCommercial_buildingCoverageLimits: {
			'& > div:last-child': {
				padding: theme.spacing(3, 0, 2, 0)
			},
			'& > div:first-child': {
				[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
					padding: theme.spacing(2, 0, 3, 0)
				},
				[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
					padding: theme.spacing(0, 0, 3, 0)
				},
			},
			'& > div:nth-child(n+2):nth-last-child(n+2)': {
				padding: theme.spacing(3, 0),
			},
			'& > div:only-child': {
				padding: theme.spacing(2, 0)
			}
		},
		formCoverageLimitsCommercial_buildingCoverageLimitsBoxInputContainer: {
			display: 'flex',
			flexDirection: 'column',
		},
	});
});

export default useStyles;
